import MarkdownPage from "../components/MarkdownPage";

export default function CompanyDetailsPage() {
    return (
        <MarkdownPage
            title="Company Details – CV Box"
            description="CV Box credit refund policy – one-time purchases, credits never expire."
            markdownFile="/content/company.md"
        />
    );
}